import { keepPreviousData } from '@tanstack/react-query'

/** Overview widgets stay fresh in-session; refresh still revalidates after persist hydrate. */
export const DASHBOARD_STALE_MS = 1000 * 60 * 10
export const DASHBOARD_GC_MS = 1000 * 60 * 60

/** Matches `DASHBOARD_OVERVIEW_CACHE_TTL_MS` on GET /portal/admin/dashboard/overview. */
export const OVERVIEW_FINANCIAL_STALE_MS = DASHBOARD_STALE_MS

export const dashboardQueryOptions = {
  staleTime: DASHBOARD_STALE_MS,
  gcTime: DASHBOARD_GC_MS,
  refetchOnWindowFocus: false as const,
  /** Hydrated sessionStorage + staleTime: paint immediately on refresh, revalidate in background when stale. */
  refetchOnMount: false as const,
  placeholderData: keepPreviousData,
}

/** Owner money-card rollup — same TTL as vehicle slices. */
export const overviewFinancialQueryOptions = {
  ...dashboardQueryOptions,
  staleTime: OVERVIEW_FINANCIAL_STALE_MS,
  refetchInterval: OVERVIEW_FINANCIAL_STALE_MS,
  refetchIntervalInBackground: true,
}
